import { RowNode } from 'ag-grid-community';
import { isDefined } from '../../../utils/utils';

export function stringArrayComparator(
  valA: string[],
  valB: string[],
  _nodeA?: RowNode,
  _nodeB?: RowNode,
  isInverted?: boolean
): number {
  // Handle null or undefined values
  if (!isDefined(valA) || !isDefined(valB)) {
    return 0;
  }

  // Handle if any of the arrays are empty
  // Handle if any of the arrays are multiples
  if (
    (valA.length === 0 && valB.length === 0) ||
    (valA.length > 1 && valB.length > 1)
  ) {
    return 0;
  } else if (valA.length === 0 || valA.length > 1) {
    return isInverted ? -1 : 1;
  } else if (valB.length === 0 || valB.length > 1) {
    return isInverted ? 1 : -1;
  }
  // Compare first elements
  return valA[0].localeCompare(valB[0]);
}
